// libs
import React from 'react';
// dls
import { BaseTheme } from '@swiggy-private/dls-web-common/dist/components';
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
import { GenericIcon } from '@swiggy-private/dls-web-icons/dist/GenericIconWeb';
import { Svg12 } from '@swiggy-private/dls-web-icons/dist/web/generic/close';
// components
import { InfoFooter } from '../InfoFooter';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// helpers
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// styles
import styles from './ChipWithInfo.module.scss';
const getChipLabelStyles = () => {
    return {
        border: `1px solid ${BaseTheme.colors.light.border_Secondary}`,
        backgroundColor: BaseTheme.colors.light.background_Primary,
    };
};
function ChipWithShadow(props) {
    const { label, onAdd, renderInfo } = props;
    const renderContent = () => {
        return (React.createElement("div", { className: styles.chip, style: getChipLabelStyles() },
            React.createElement("div", { className: styles.chipLabel },
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Med }, label),
                React.createElement(Text, { variant: DlsFontVariants.body_B3_Reg, color: DlsColorTokens.text_Low_Emphasis }, prefixWithRupee(formatNumberIntl({ value: props.price })))),
            React.createElement("div", { role: "button", className: styles.chipAddButtonContainer, onClick: onAdd },
                React.createElement(GenericIcon, { Icon: Svg12, className: styles.chipAddButton }))));
    };
    const renderChipInfo = () => {
        return (renderInfo && React.createElement("div", { className: styles.chipInfo }, renderInfo()));
    };
    return (React.createElement(InfoFooter, { renderInfo: renderChipInfo, renderContent: renderContent }));
}
export default ChipWithShadow;
